import Vue from 'vue';
import Hagrid from 'vue-hagrid';

const hagrid = new Hagrid();
Vue.use(hagrid);
window.hagrid = hagrid;
export default hagrid;



// WEBPACK FOOTER //
// ./src/hagrid.js